module.exports = __webpack_public_path__ + "static/media/HeaderArrow.4478239a.svg";